import styled from 'styled-components'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import { Link } from '@navent-jobs/ui-kit/components/link'

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const IconCustom = styled(Icon)`
  ${({ marginRight }) => marginRight && `margin-right: ${marginRight}`}
`

export const ButtonEstadisticas = styled(Link)`
  display: flex;
  direction: row;
  align-items: center;
  padding: 8px;
  width: max-content;

  border: 1px solid ${({ theme }) => theme.colors.primary.normal};

  &:hover,
  &:focus:not(:active) {
    border: 1px solid ${({ theme }) => theme.colors.primary.normal};
  }

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    margin-bottom: 8px;
  }
`

export const LabelButtonEstadisticas = styled('p')`
  line-height: 16px;
  margin: 0;
  padding: 0px 12px 0px 8px;
`

export const WordingContainer = styled('div')`
  padding: ${({ hasPreguntasPendientes }) => (hasPreguntasPendientes ? '15px 0 16px 0' : '21px 0')};
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    ${({ hasPreguntasPendientes }) => !hasPreguntasPendientes && 'padding: 60px 0px'};
  }
`
